import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function DeleteAccount() {
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleDeleteAccount = () => {
    const cleanedPhone = phone.replace(/\D/g, "");

    if (!cleanedPhone) {
      toast.error("Please enter your phone number.", {
        className: "custom-toast error-toast",
      });
      return;
    }

    if (cleanedPhone.length < 10) {
      toast.error("Please enter a valid phone number.", {
        className: "custom-toast error-toast",
      });
      return;
    }

    setLoading(true);

    setTimeout(() => {
      setLoading(false);

      toast.success("Your account is deleted successfully.", {
        className: "custom-toast success-toast",
      });

      setTimeout(() => {
        navigate("/auth-login");
      }, 1000);
    }, 1000);
  };

  return (
    <div className="delete-page">

      <div className="delete-wrapper">
        <div className="delete-topbar">
          <div className="danger-badge">Sensitive Action</div>
        </div>

        <div className="delete-card">
          <div className="icon-wrap">
            <div className="icon-circle">
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M3 6h18" />
                <path d="M8 6V4h8v2" />
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                <path d="M10 11v6" />
                <path d="M14 11v6" />
              </svg>
            </div>
          </div>

          <h1 className="delete-heading">Delete Account</h1>
          <p className="delete-description">
            Enter your registered phone number to permanently delete your account.
            Once deleted, your access will be removed and this action cannot be undone.
          </p>

          <div className="warning-box">
            <h3>Before you continue</h3>
            <ul>
              <li>Your profile access will be removed.</li>
              <li>Your account will no longer be available after deletion.</li>
              <li>Please make sure the phone number belongs to your account.</li>
            </ul>
          </div>

          <div className="input-block">
            <label htmlFor="phoneNumber">Phone Number</label>
            <input
              id="phoneNumber"
              type="tel"
              inputMode="numeric"
              maxLength={10}
              placeholder="Enter registered phone number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>

          <button
            type="button"
            className="delete-btn"
            onClick={handleDeleteAccount}
            disabled={loading}
          >
            {loading ? (
              <span className="btn-loader-wrap">
                <span className="btn-loader"></span>
                Deleting...
              </span>
            ) : (
              "Delete Account"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}